// extracted by mini-css-extract-plugin
module.exports = {"deleteModalWrapper":"DeletionModal_deleteModalWrapper__2DYM8","buttonWrapper":"DeletionModal_buttonWrapper__1dgeb"};